angular.module('impactx.list').directive('appListLink', function()
{
    return {
        scope: {
            translation: '@',
            link: '@',
            process: '@',
            icon: '@'
        },
        restrict: 'E',
        controller: 'ListActionCtrl',
        templateUrl: 'shared/list/templates/listLinkView.html',
        transclude: true
    };
});